























import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import BasePage from '@/tcw/components/BasePage'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import KoutsuhiPatternForm from '../organisms/KoutsuhiPatternForm.vue'

@Component({
  components: { TcwLayoutBasicTemplate, KoutsuhiPatternForm }
})
export default class KoutsuhiPatternInputPage extends Mixins(BasePage) {
  private get patternId(): string | null {
    if (this.routeParams['patternId']) {
      return this.routeParams['patternId']
    } else {
      return null
    }
  }
  protected get form(): FormStoreComponent {
    return this.$refs.form as FormStoreComponent
  }

  protected save(): void {
    this.form.startSaveProc()
  }
}
